import React from 'react'
import { Row, Col, Container, Button } from 'react-bootstrap'

const Header = () => {
  return (
    <div className='header pt-5'>
      <Container>
        <Row xs={1} md={2} lg={2}>
        
        <Col>
          <div className='text-center pt-3 px-3 mb-3'>
                <img src='/images/header-img4.svg' alt='...' className='img img-fluid d-block' />
          </div>
        </Col>
        <Col>
          <div className='title-section-container pt-3 px-2 mb-4'>
            <div class='title-section'>
                <h4 className='mb-5 text-secondary fw-bold'>I.T Logists...</h4>
                <h1 className='text-capitalize fw-bold mb-0'>
                  We build with <span>Inovative</span> and <span>Insightful</span> technologies.
                </h1>
                <p className='lead fs-4 text-secondary mt-0 mb-5'>
                  Re-inventing commerce, empowering people.
                </p>
                <Button className='btn btn-lg rounded-pill btn-outline-light service-btn'>Our Services</Button>
            </div>
          
          </div>
        </Col>
      </Row>
      </Container>
      
    </div>
  )
}

export default Header